import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const CommonSpan = styled.div`
  font-size: 14px;
  ${semiBoldAlias()}
  color: var(--section-ebony-light-color,var(--ebony-light));
  word-break: break-word;
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const Total = styled.div`
  background-color: var(--input-ice-background-color, var(--ice));
  border: 1px solid var(--input-transparent-border-color, var(--transparent));
  height: 40px;
  padding: 0 16px;
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 14px;
  width: 264px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: flex;
    align-items: center;
  }
`;

export const Amount = styled.span`
  font-size: 16px;
  ${semiBoldAlias()};
`;

export const Wrapper = styled.div`
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: var(--section-snow-background-color, var(--snow));
  &:not(.open):hover {
    background-color: var(--section-snow-background-color, var(--snow));
  }

  &:is(.plan-detail-open) {
    margin-bottom: 16px;
  }

  .control svg {
    transition: transform 0.3s ease-in-out;
  }

  .head.open {
    background-color: var(--section-snow-background-color, var(--snow));
    background-color: var(--section-ice-background-color, var(--ice));
    border-radius: 4px 4px 0 0;

    svg.open-chevron {
      transform: rotate(180deg);
    }
  }
`;

export const HeadingContainer = styled.div`
  position: relative;
  .wide {
    @media (max-width: 750px) {
      display: none;
    }
  }
  .narrow {
    @media (min-width: 750px) {
      display: none;
    }
  }
  .control {
    display: flex;
    gap: 8px;
    position: absolute;
    justify-content: end;
    right: 20px;
    top: 0;
    align-items: center;
    height: 100%;
  }
`;

export const Heading = styled.div`
  position: relative;
  padding: 24px 32px;
  padding-right: 90px; //needs to push content from overflowing

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 24px;

  align-items: center;
  word-break: break-word;
`;

export const GridList = styled(Heading)`
  padding: 16px 32px;
  @media (min-width: 750px) {
    padding-right: 90px; //needs to push content from overflowing
  }
  & {
    :is(:first-child) {
      padding-top: 20px;
    }
    :is(:last-child) {
      padding-bottom: 32px;
    }
  }
`;

export const AccordionItem = styled.div`
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
  transition:
    max-height 0.2s ease-in-out,
    opacity 0.3s ease-in-out;
  will-change: max-height;
  &.open {
    opacity: 1;
    max-height: 500px;
    box-shadow: ${props =>
      props.theme.name === "dark"
        ? "0px 6px 44px #01001A"
        : "0px 10px 20px rgba(75, 97, 128, 0.08)"};
  }
`;

export const ProjectTitle = styled(CommonSpan)``;

export const ProjectPlan = styled(CommonSpan)``;

export const ProjectRegion = styled(CommonSpan)``;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  padding-top: 50px;
`;
